import toast from 'Shared/toast';
import { useMutation, useQueryClient } from 'react-query';
import UserService from 'App/services/UserService';

function useUpdateMyAccountDetailsMutation() {
    const queryClient = useQueryClient();

    return useMutation(
        (reqBody) => {
            return UserService.saveMyAccountDetails(reqBody);
        },
        {
            onSuccess: async (res) => {
                toast.success(res.message);
                await queryClient.invalidateQueries('myAccountDetails');
            },
        }
    );
}

export default useUpdateMyAccountDetailsMutation;
